var staticStrUndefined = require('./staticStrUndefined')

/* eslint-disable valid-typeof */
var staticDocument = typeof document === staticStrUndefined ? 0 : document

module.exports = staticDocument



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticDocument.js
// module id = 289
// module chunks = 75